export const Labels = {
  Success: 'success',
  Error: 'error',
  Login_Success: 'Login successfully',
  Upload_Success: 'Uploaded successfully',
  Update_Success: 'Update Successfully',
  Email_Success: 'Email Sent Successfully',
  Save_Success: 'Save Successfully',
  Delete_Success: 'Delete Successfully',
};
export const BaseImageUrl = 'https://androidtokyo.s3.amazonaws.com/';

export const Apis = {
  // Constant
  getStateList: 'v0/ui/state/',
  getCityList: 'v0/ui/create_supplier/load_initial_data/',
  getAreaList: 'v0/ui/locations/',
  getOrganisationsList: 'v0/ui/website/organisation/get_organisations_for_assignment/',
  getUserMinimalList: 'v0/ui/website/get-users-minimal-list/',
  getMachadaloStatusList: 'v0/ui/b2b/machadalo-client-status-list/',
  getRoleByOrganisation: 'v0/ui/website/role/?organisation_id=',
  getAccountsList: 'v0/ui/website/account/',
  getProposalsList: '/v0/ui/website/child-proposals/0/',
  updateAccount: 'v0/ui/website/account/',
  uploadFileS3Bucket: 'v0/ui/bot-builder/upload-file-to-s3/',

  New_Leads_Campaign: 'v0/ui/b2b/get-basic-lead-distribution-campaign/?tabname=basic',
  Lead_By_Campaign: 'v0/ui/b2b/get-dynamic-basic-lead-form-headers/',
  Client_Status_By_Campaign: 'v0/ui/b2b/machadalo-client-status-list/?campaign_id=',
  SendEmail_By_Campaign: 'v0/ui/b2b/email-leads-summary/',
  Update_Client_Status: 'v0/ui/b2b/update-machadalo-client-status/',
  Get_Comment_List: 'v0/ui/b2b/basic-client-comment/',
  Accept_Decline_Leads: 'v0/ui/b2b/update-client-decision-status/',
  Upload_Comments_File: 'v0/ui/b2b/upload-lead-comments/',
  Get_Leads_By_Supplier: 'v0/ui/b2b/supplier-leads-decision-pending/?supplier_id=',

  // Campaign
  Get_Invoice_Proposals: 'v0/ui/website/proposal/invoice_proposals/',
  // Get_User_Minimal_List: 'v0/ui/website/get-users-minimal-list/',
  Get_Organisation_List: 'v0/ui/website/organisation/',

  // Campaign List
  Get_Campaign_Assignment: 'v0/ui/website/campaign-assignment/',
  getCampaingByOrganisation: 'v0/ui/bot-builder/campaign-list',
  Download_Campaign_Sheet: 'v0/ui/leads/generate-campaign-hash/',
  Campaign_Send_Email: 'v0/ui/website/',
  Campaign_Wise_Summary: 'v0/ui/campaign/campaign-wise-summary/',
  Suspense_Leads: 'v0/ui/b2b/suspance-leads/',
  Suspense_Lead_Count: 'v0/ui/b2b/suspance-leads-count/',
  All_Suspense_Leads: 'v0/ui/b2b/suspense-leads/',

  // Booking Plan
  Get_Header_Data: 'v0/ui/getHeaderData',
  Get_Relationship_Data: 'v0/ui/website/get-relationship-and-past-campaigns-data/?',
  Get_Contact_Details: 'v0/ui/website/inventory-contact-details/?',
  Post_Brand_Assignment: 'v0/ui/website/brand-assignment/',
  Post_Supplier_Assignment: 'v0/ui/website/supplier-assignment/',
  Get_Permission_Box_Images: 'v0/ui/website/hashtag-images/get_permission_box_images/',
  Post_permission_Box_Images: 'upload_permission_box_image/',
  Get_Receipt_Images: 'v0/ui/website/hashtag-images/get_receipt_images/',
  Post_Receipt_Images: 'upload_receipt_image/',
  Get_Supplier_Phase: 'v0/ui/website/supplier-phase/',
  Get_Booking_Status: 'v0/ui/website/booking-status/',
  Post_Supplier_Phase: 'v0/ui/website/supplier-phase/',
  Delete_Supplier_Phase: 'v0/ui/website/supplier-phase/',
  Send_Email_Payment_Detail: 'v0/ui/website/mail/',
  Get_Proposal_Centre_Mapping: 'v0/ui/website/proposal-center-mapping/',
  Update_Cheque_Detail: 'v0/ui/society/',
  Put_Assign_Supplier_User: 'v0/ui/website/assign-supplier-users/',
  Get_Area_By_city: 'v0/ui/getCityArea?search=',
  Get_Sub_Area: 'v0/ui/locations/',
  Supplier_Search: 'v0/ui/website/supplier-search/',
  Post_Supplier_List: 'v0/ui/website/add-suppliers-direct-to-campaign/',
  Delete_Camapign_Inventory: 'v0/ui/website/delete-shortlisted-spaces/',
  Get_Inventory_List: 'v0/ui/website/short-listed-inventories/',

  // OPS VERIFY
  Get_Sector_List: 'v0/ui/b2b/sector-list/',
  Get_Leads_By_Sector: 'v0/ui/b2b/sector-wise-lead-details/',
  getQuetionsByNumber: 'v0/ui/b2b/dropdown-filter-by-sector/',
  updateLeadData: 'v0/ui/b2b/requirements/',
  getAllSectors: 'v0/ui/accounts/create_business/load_business_types/',
  postLeadData: 'v0/ui/b2b/submit-tab-update-leads/',
  opsVerifiedLeads: 'v0/ui/b2b/ops-lead-verification/',
  getClientComments: 'v0/ui/b2b/client-commits-ops/',
  getInternalComments: 'v0/ui/b2b/internal-comment/',

  // Intervene
  // getActiveUser: 'v0/ui/b2c-bot/active-users/',
  // getActionUser: 'v0/ui/b2c-bot/action_required/',
  // getInterveneUser: 'v0/ui/b2c-bot/intervene/',
  // getHistoryUser: 'v0/ui/b2c-bot/get-all-users-paginate/',
  getUserDetails: 'v0/ui/b2c-bot/get-user-details/',
  getUserJuorney: 'v0/ui/b2c-bot/user-journey/',
  getSupplierList: 'v0/ui/b2c-bot/supliers-filter-list/',
  getDialerCallerIds: 'v0/ui/mca-bot/dailer-caller-ids/',
  getDialerAgents: 'v0/ui/mca-bot/dailer-agents/',
  postDialerCall: 'v0/ui/mca-bot/dailer-call/',
  getSupplierByNumber: 'v0/ui/b2b/supplier-list/',
  getsupplierDetails: 'v0/ui/b2b/suspense-tab-by-supplier/',
  postSupplierDetails: 'v0/ui/b2b/suspense-to-supplier-for-new/',
  getPostSocietyImages: 'v0/ui/image-mapping/',
  getAllChannels: 'v0/ui/intervene/get-all-chennels/',
  getActiveUser: '/v0/ui/intervene/active-chat-user/',
  startEndSession: '/v0/ui/intervene/intervene-session/',
  getChatUsersCounts: '/v0/ui/intervene/chat-users-counts/',
  // CHAT summary
  getFlowListByBotNumber: 'v0/ui/intervene/get-flow-list/',
  getUserChatSummary: '/v0/ui/intervene/user-conversation-list/',
  // Orders
  getOrderList: 'v0/ui/whatsapp/orders/',
  getOrderDetails: 'v0/ui/whatsapp/order-details/',
  downloadOrderData: 'v0/ui/whatsapp/update-order-status/',
  getChannelSalesPartners: 'v0/ui/whatsapp/channel-sales-partners/',
  getOrderCityList: 'v0/ui/whatsapp/order-city-list/',

  // Template
  getTemplateList: 'v0/ui/template/view-template/',
  sendTemplate: 'v0/ui/template/send-template/',
  getWhatsappTemplate: 'v0/ui/whatsapp/template-list/',
  whatsappTemplate: '/v0/ui/whatsapp/template/',
  sendWhatsappTemplate: '/v0/ui/whatsapp/send-template/',
  uploadUserData: 'v0/ui/template/send-template-by-sheet/',
  uploadHeaderFile: '/v0/ui/whatsapp/upload-media-file/',
  //uploadHeaderWhatsapp: '/v0/ui/bot-builder/upload-media-to-whatsapp',
  getTemplateDateWiseSumnary: 'v0/ui/mca-bot/template-date-wise-summary/',
  getTemplateUserSummary: 'v0/ui/mca-bot/template-user-summary-list/',
  updateTemplateCallStatus: 'v0/ui/template/update-call-status-template',
  postTemplateUserComment: 'v0/ui/template/update-comment-template',
  sendTemplateCron: 'v0/ui/template/v1/send-template-cron',
  getWhatsappBusinessInfo: '/v0/ui/whatsapp-v2/get-whatsapp-business-info/',
  registerWhatsappWebhook: '/v0/ui/whatsapp-v2/register-webhook/',
  getOptinList: '/v0/ui/whatsapp-v2/optin-list/',
  optinDownload: '/v0/ui/whatsapp-v2/optin-download/',

  // Product
  getProductItemList: '/v0/ui/whatsapp/product-list/',
  refreshProductList: '/v0/ui/whatsapp/refresh-product/',
  getCatalogList: '/v0/ui/whatsapp/catalog-list/',
  postProductSetsList: '/v0/ui/whatsapp/product-sets-list/',
  produtItem: '/v0/ui/whatsapp/product-item/',

  // Lead Form
  updateLeadStatus1: 'v0/ui/b2b/b2c-lead-status/',
  updateLeadStatus: 'v0/ui/b2b/b2c-lead-status1/',
  addReferences: 'v0/ui/b2b/b2c-lead-references/',
  getPostComment: 'v0/ui/b2b/b2c-lead-comments/',
  getPostLeadImagesById: 'v0/ui/b2b/b2c-lead-images/',
  getPostLeadAudioById: 'v0/ui/b2b/b2c-lead-audio/',
  // getDetailsByNumber: 'v0/ui/dynamic-bot/google-spreadsheet-data/',
  getDetailsByNumber: 'v0/ui/dynamic-bot/get-raw-data/',
  getRawLeadForm: 'v0/ui/dynamic-bot/get-raw-lead-form/',

  getLeadCountsByParams: 'v0/ui/leads/get-summary-supplierwise-leads/',
  updateQcStatus: 'v0/ui/b2b/update-qc-status/',
  // getLeadsCampaignSupplier: 'v0/ui/b2b/get-leads-campaign-supplier/',
  // getLeadDataByLeadId: 'v0/ui/b2b/get-leads-campaign-supplier-by-id/',
  postInterveneCdrData: 'v0/ui/intervene/store-cdr/',
  getAgentSummaryData: 'v0/ui/intervene/get-all-call-data/',
  getAgentDatewiseSummaryData: 'v0/ui/intervene/get-agent-datewise-summary/',
  getAgentUsers: 'v0/ui/intervene/get-cdr-data/',

  // Organisation Management
  addUpdateCompanyAdd: 'v0/ui/accounts/company-address-details/',
  createCompanyGst: 'v0/ui/accounts/company-gst-details/',
  getRoleList: 'v0/ui/website/role/',
  getProfileList: 'v0/ui/website/profile/',
  createProfile: 'v0/ui/website/profile/',
  getContentTypes: 'v0/ui/website/content-type/',
  objectLevelPermission: 'v0/ui/website/object-level-permission/',
  generalUserPermission: 'v0/ui/website/general-user-permission/',
  getUsersByOrganisation: 'v0/user/',
  unlockUser: '/v0/unlock-user/',

  // Flow Builder
  getFlowList: 'v0/ui/bot-builder/flow/list/',
  createFlow: 'v0/ui/bot-builder/flow/create',
  createNodeEdges: 'v0/ui/bot-builder/node/edges/create/',
  getNodeEdges: 'v0/ui/bot-builder/node/edges/details/',
  getBotFlowDetails: 'v0/ui/bot-builder/flow/details/',
  scheduleBot: 'v0/ui/bot-builder/schedule-bot/',
  updateFlow: 'v0/ui/bot-builder/flow/update',
  deleteFlow: 'v0/ui/bot-builder/flow/delete',
  checkPatterns: '/v0/ui/bot-builder/check-patterns',
  checkFlowName: 'v0/ui/bot-builder/check-flow',
  uploadMediaToWhatsapp: 'v0/ui/bot-builder/upload-media-to-whatsapp',
  whatsappBusinessAccounts: 'v0/ui/bot-builder/whatsapp-business-account/list',
  getBotBuilderCatalogList: 'v0/ui/bot-builder/catalog-by-phone-number-id/list',
  getBotBuilderProductList: 'v0/ui/bot-builder/products-by-catalog/list',
  fetchFlowDetailByFlowType: '/v0/ui/bot-builder/flow-type-flow-details/',
  checkFormValidation: 'v0/ui/bot-builder/check-validation-flow/',
  smsTemplate: 'v0/ui/sms/sms-template/',
  smsSendTemplate: 'v0/ui/sms/send-template/',
  generateApiKey: '/v0/generate-token/',
  botAuthentication: 'v0/ui/whatsapp-v2/bot-authentication',
  getActivityLogs: 'v0/ui/b2b/user-activity-logs/',
  smsReportView: '/v0/ui/sms/report-sms-view/',
  smsReportDownload: '/v0/ui/sms/report-sms-download/',
  //entity management
  entityForm: '/v0/ui/entity-management/form/',
  getEntityFormById: '/v0/ui/entity-management/get-form/',
  entityManagement: '/v0/ui/entity-management/',
  uploadEntityData: '/v0/ui/entity-management/bulk-upload-entity',
  downloadEntitySampleFile: '/v0/ui/entity-management/download-entity-sample-file',
  getEntityDataById: '/v0/ui/entity-management/get-entity-data/',
  entityDropdownUniqueRecord: '/v0/ui/entity-management/entity-data-unique-record/',

  // Leads
  getB2b2cLeads: 'v0/ui/leads/get-b2b2c-leads/',
  CampaignWiseLeadSummary: 'v0/ui/leads/get-summary-campaign-wise/',
  updateStatusComment: 'v0/ui/leads/update-lead-comment/',
  statusSubStatus: 'v0/ui/leads/lead_form_status/',
  createCampaignMapping: 'v0/ui/proposal/create-campaign-mapping/',
  insertLeadV1: 'v0/ui/leads/lead-api-v1/',
  downloadB2b2cLeads: 'v0/ui/leads/Download-b2b2c-leads/',
  // getPerformanceMetrics: 'v0/ui/leads/conversation-rate/',

  // Leads Schedular
  leadSchedular: 'v0/ui/leads/create-scheduler/',
  // Login
  login: 'api-token-auth/',
  forgotPassword: 'v0/ui/forgotPassword',
  guestLogin: 'v0/ui/guest-user/',
  chatgpt: 'v0/ui/whatsapp-v2/chatgpt-key',
  resetPassword: 'v0/ui/setResetPassword',
  convertAudioToText: 'v0/ui/ai-agent/audio-to-text/',

  // AI-dashboard
  createProject: '/v0/ui/whatsapp-v2/create-project/',

  //Report Dashboard
  deleteReport: '/v0/ui/report/api/report-templates/',
  htmlPreview: '/v0/ui/report/api/reports/generate/',
  getTemplate: '/v0/ui/report/api/report-templates/',
  getReportTemplate: '/v0/ui/report/api/report-templates/',
  updateReport: '/v0/ui/report/api/report-templates/',
  generateReport: '/v0/ui/report/api/',
  scheduleOptions: '/v0/ui/report/triggers/schedule-options/',
  templateTriggers: '/v0/ui/report/templates/',

  // Knowledge APIs
  knowledgeList: '/v0/ui/school/knowledge/',
  testDoubtData: '/v0/ui/school/get-test-doubt-data',
  imageUrl: 'v0/ui/ai-agent/generate-image-async',
  practiceTest: '/v0/ui/school/generate-test-from-question-bank/',

  // Question Bank APIs
  questionBank: '/v0/ui/school/questions-bank/',
  downloadTestExcelSample: '/v0/ui/school/download-test-excel-sample/',
};
